import { useEffect } from 'react';
import {setCabinetGLBFromCabinetsSet} from "../helpers/sqft3dArHelper";
import {setLookActiveCategory} from "../../../actions/lookFunctions";
import store from "../../../store";
//import {setMultiLoader} from "../../../actions/actionFunctions";
import {SHAPE_PART_ID} from "../constants";
import {getCurrentLayout} from "../../appLayout";
import workspace from "../components/canvas/core/workspace";
import {
  syncBathroomCabinetParentFeaturesFromVanity
} from "../components/navigation/menu/cabinet/toolMenu/helpers/cabinetParentFeatureResolver";

const useChangeCabinetsColor = (lookActiveFeature) => {
  useEffect(() => {
    // wi will display door styles for this category

    const state = store.getState()
    const {displayDoorsOnly} = state.serverState;


    setLookActiveCategory(SHAPE_PART_ID.top_cabinet);

    // store.dispatch(setMultiLoader({activeStep: 0, visible: false, finished: false}));
    // store.dispatch(setMultiLoader({activeStep: 0, visible: true, finished: false}));

    //todo update lower and bottom separately
    //sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(lookActiveFeature);
    const inheritedBathroomFeatures = syncBathroomCabinetParentFeaturesFromVanity({
      layout: getCurrentLayout(),
      vanityFeature: lookActiveFeature,
    });
    inheritedBathroomFeatures.forEach(inheritedFeature => {
      workspace.getShapes()
        .filter(shape => {
          return shape.parentPartId === inheritedFeature.partId
            || shape.grandParentPartId === inheritedFeature.partId;
        })
        .forEach(shape => {
          if (typeof shape.changeFeatureIdIfColorWasChanged === "function") {
            shape.changeFeatureIdIfColorWasChanged(inheritedFeature);
          }
        });
    });

    setCabinetGLBFromCabinetsSet(displayDoorsOnly).then(r => void r);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature])
};

export default useChangeCabinetsColor;
